import { makeStyles, Theme } from '@material-ui/core';

export const FOOTER_MIN_HEIGHT = 64;

export const useFooterStyles = makeStyles<Theme>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.common.white,
    color: '#000',
    paddingTop: '8px',
    paddingBottom: '8px',
    height:'100px',
    overflow:'hidden',
    [theme.breakpoints.down(992)]: {
      height:'auto',
    },
  },

  container: {
    width:'100%',
    maxWidth:'1280px',
    margin:'0 auto',
    padding:0,
    display:"flex",
    alignItems:'center',
    justifyContent:"space-between",
    [theme.breakpoints.down(1500)]: {
      width:'980px',
    },
  },
  containerMobile: {
    width:'100%',
    margin:'0 auto',
    padding:'0 10px 20px',
  },
  copyright: {
    fontSize: 18,
    textAlign: 'center',
    marginTop: '48px',
    '& img': {
      height: '42px',
      maxWidth:'100%'
    }
  },
  list: {
    display: 'flex',
    width: '600px',
    justifyContent: 'space-between',
    '& ul': {
      padding: '0'
    },
    '& li': {
      listStyle: 'none',
      marginTop: '16px',
      color: '#8787A2',
      fontSize: '14px',
      lineHeight: '22px',
      cursor: 'pointer',
      '&:first-child': {
        marginTop: '0',
        fontSize: '16px',
        lineHeight: '24px',
        cursor: 'auto',
        color: '#fff'
      },
    }
  },
  join: {
    display: 'flex'
  },
  iconSvg: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    width: '48px',
    height: '48px',
    marginRight: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    cursor: 'pointer',
    '& img': {
      display: 'block'
    }
  },
  terms: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '24px',
    fontSize: '13px',
    fontWeight: 400,
    '& p': {
      margin: '0 14px',
      letterSpacing: '1.04px',
    },
    [theme.breakpoints.down(576)]: {
      marginTop: '0',
    },
  },
  copy: {
    marginTop: '6px',
    textAlign: 'center',
    fontSize:'12px',
    color:'#666',
    fontWeight:400,
  },
  footerCenter:{
    textAlign:'center',
  },
  links:{
    fontSize:'20px',
    paddingLeft:'0',
    [theme.breakpoints.down(992)]: {
      backgroundColor: '#fff',
      fontSize:'14px',
      padding: '6px 4px',
    },
  },
  logoBox:{
    position:'relative',
    width:'100%',
    marginTop:'20px',
  },
  lines:{
    width:'100%',
    position:'absolute',
    left:0,
    top:'50%'
  },
  footLogo:{
    width:'40px'
  }
}));
